import { CommonModule } from '@angular/common';
import { Component, HostBinding, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import {
  DateRange,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerModule,
  MatDateRangeSelectionStrategy,
} from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import moment from 'moment-timezone';
import { VizFormModule } from './common/components/form/form.module';
import { date_utils } from './common/date_utils';
import { TimeAtom } from './common/timespan/time_utils';
import { EmptyObject } from './common/utils';
import { TSpaceType } from './core/entities';
import { SiteLangMixin } from './core/lang';
import { SessionCache } from './session.cache';
import { SessionService, TIMEZONE } from './session.service';
import {
  formatDisplayTime,
  SiteFormatMixin,
} from './thinkdesks/site.format.mixin';
@Injectable()
export class MaxRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  start: any;
  public delta: number = 2;
  constructor(private _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D, currentRange: DateRange<D>) {
    let { start, end } = currentRange;
    if (start == null || (start && end)) {
      start = date;
      end = null;
    } else if (end == null) {
      const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
      end = date ? (date > maxDate ? maxDate : date) : null;
    }

    return new DateRange<D>(start, end);
  }
  createPreview(
    activeDate: D | null,
    currentRange: DateRange<D>
  ): DateRange<D> {
    if (currentRange.start && !currentRange.end) {
      const maxDate = this._dateAdapter.addCalendarDays(
        currentRange.start,
        this.delta
      );
      const rangeEnd = activeDate
        ? activeDate > maxDate
          ? maxDate
          : activeDate
        : null;

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<D>(null, null);
  }
}

@Component({
  selector: 'app-space-wizard-page',
  standalone: true,
  imports: [CommonModule, MatSelectModule, MatDatepickerModule, VizFormModule],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy,
    },
  ],
  templateUrl: './space.wizard.page.html',
})
export class SpaceWizardPage extends SiteFormatMixin(
  SiteLangMixin(EmptyObject)
) {
  @HostBinding('class') css = 'max-scroll';
  _common = _common;

  step = 0;

  spaceTypes: TSpaceType[] = [];
  allSpaceTypes = false;
  spaceType: TSpaceType[] = [];

  area: string = '';
  district: string = '';

  all = { id: 0 } as any;
  allCapacity = { min: 0, max: 0 };
  capacities = [
    { min: 1, max: 5 },
    { min: 6, max: 10 },
    { min: 11, max: 20 },
    { min: 21 },
  ];
  capacity: any;

  date: moment.Moment;
  minDate: moment.Moment;
  maxDate: moment.Moment;
  maxDays = 14;

  allHours = -1;
  hours: { hour: number; text: string }[] = [];
  hour: any = this.allHours;

  constructor(
    private cache: SessionCache,
    private snackBar: MatSnackBar,
    override session: SessionService,
    private router: Router
  ) {
    super();
    this.cache.loadSpaceTypes((list) => {
      this.spaceTypes = list.map((c) => Object.assign({}, c));
    });
    this.minDate = moment.tz(TIMEZONE).startOf('day');
    this.maxDate = this.minDate.clone().add(this.maxDays - 1, 'day');

    this.date = this.minDate.clone();
    let now = moment();
    for (let i = 0; i < 24; i++) {
      let atom = new TimeAtom(i);
      let tt = atom.moment(now);
      this.hours.push({
        hour: atom.toTime(),
        text: formatDisplayTime(this.session, tt),
      });
    }
    this.hours = [
      ...this.hours.slice(6),
      ...this.hours.slice(0,6),
      
    ]
  }
  ngOnInit() {}
  step0() {
    this.step = 0;
  }
  step1() {
    if (!this.spaceType?.length && !this.allSpaceTypes) {
      this.snackBar.open(_common.findSpace.error_selectOne);
      return;
    }
    this.step = 1;
  }

  updateArea() {
    this.district = '';
  }
  step2() {
    this.step = 2;
  }

  step3() {
    this.step = 3;
  }
  step4() {
    this.step = 4;
  }
  toggleSpace(t: TSpaceType) {
    let index = this.spaceType.indexOf(t);
    if (index >= 0) {
      this.spaceType.splice(index, 1);
    } else {
      this.spaceType.push(t);
    }
    this.allSpaceTypes = false;
  }
  clearSpace() {
    this.spaceType = [];
    this.allSpaceTypes = true;
  }
  proceed() {
    let query = {
      date: date_utils.toQuery(this.date),
    };
    if (this.hour >= 0) {
      query['hour'] = this.hour;
    }
    if (this.spaceType.length) {
      query['type'] = this.spaceType.map((c) => c.id);
    }
    if (this.district && this.district != '') {
      query['district'] = this.district;
    }
    if (this.area && this.area != '') {
      query['area'] = this.area;
    }
    if (this.capacity) {
      if (this.capacity.min) {
        query['capacityMin'] = this.capacity.min;
      }
      if (this.capacity.max) {
        query['capacityMax'] = this.capacity.max;
      }
    }
    this.router.navigate([this.session.path('/space-search-result')], {
      queryParams: query,
    });
  }
}
